export function watchForMenuClick() {
  const openMenuButton = document.querySelector('.open_menu');
  const closeMenuButton = document.querySelector('.close_menu');
  const closeMenuButtonText = document.querySelector('.close_menu_actions');
  const openSearchButton = document.querySelector('.open_search');
  const subnavBtn = document.querySelectorAll('.has-sub-nav');

  subnavBtn.forEach(btn => {
    btn.addEventListener('click', toggleSubnav);
  });

  if (openMenuButton && closeMenuButton && closeMenuButtonText) {
    openMenuButton.addEventListener('click', openNav);
    closeMenuButton.addEventListener('click', closeNav);
    closeMenuButtonText.addEventListener('click', closeNav);
  }

  if (openSearchButton) {
    openSearchButton.addEventListener('click', openNav);
  }
}

function checkForMobileNav(event) {
  if (window.innerWidth > 991) {
    closeEverything();
    const tertiaryNavs = [];
    tertiaryNavs.push(document.getElementById('productTypes'));
    tertiaryNavs.push(document.getElementById('productFamilies'));
    tertiaryNavs.forEach(nav => {
      if (nav) {
        nav.removeAttribute('style');
        if (nav.classList.contains('pane')) {
          nav.classList.remove('pane');
        }
      }
    });

    const productDisplayNav = document.querySelector('.product-display-nav');

    if (productDisplayNav) {
      const height = productDisplayNav.offsetHeight;
      const gridTitleContainers = document.querySelectorAll('.grid_title_container');
      gridTitleContainers.forEach(container => {
        container.style.marginTop = `${height}px`;
      });
    }
  } else {
    const menu = document.getElementsByClassName('menu');
    const siteLogoContainer = document.getElementsByClassName('site_logo');

    Array.from(menu).forEach(ele => {
      ele.classList.add('mobile');
    });
    Array.from(siteLogoContainer).forEach(ele => {
      ele.classList.add('mobile');
    });
  }
}

function openNav(event) {
  document.documentElement.classList.add('menu_open');
}

function closeEverything() {
  document.documentElement.classList.remove('menu_open');
  const mainNav = document.querySelector('.main-nav');

  if (mainNav) {
    mainNav.querySelectorAll('.active').forEach(element => element.classList.remove('active'));
    mainNav.querySelectorAll('.backgrounded').forEach(element => element.classList.remove('backgrounded'));
  }
}

function closeNav(event) {
  if (event.target.classList.contains('close_menu_actions')) {
    closeEverything();
  } else if (tertiaryNavOpen()) {
    closeTertiary();
  } else if (secondaryNavOpen()) {
    closeSecondary();
  } else {
    closeEverything();
  }

  if (event.target.classList.contains('back')) {
    event.target.removeEventListener('click', closeNav);
  }
}

function closeTertiary() {
  const subnav = document.querySelector('.tertiary-nav');
  const subnavContainer = document.querySelector('.secondary-nav-container');
  const sublist = document.querySelector('.subnav');
  if (subnav.classList.contains('active')) {
    const lists = subnav.querySelectorAll('div');
    subnav.classList.remove('active');
    subnavContainer.classList.remove('active');
    sublist.classList.remove('backgrounded');
    lists.forEach(list => list.style.display = 'none');
  }
}

function closeSecondary() {
  closeTertiary();
  const sublist = document.querySelectorAll('.subnav');
  sublist.forEach(sub => sub.classList.remove('active'));
  document.querySelector('.close_menu').innerHTML = 'Close';
}

function secondaryNavOpen() {
  const sublist = document.querySelectorAll('.subnav');
  let activeSecondaries = false;
  sublist.forEach(list => {
    if (list.classList.contains('active')) {
      activeSecondaries = true;
    }
  });
  return activeSecondaries;
}

function tertiaryNavOpen() {
  const sublist = document.querySelector('.subnav');
  return sublist.classList.contains('backgrounded');
}

function revealTertiary(event) {
  const id = event.target.dataset.id;
  const tertiary = document.getElementById(id);
  const parent = tertiary.parentNode;
  const gparent = parent.parentNode;
  tertiary.style.display = 'block';
  tertiary.classList.add('pane');
  parent.classList.add('active');
  gparent.classList.add('active');
  activateOverlayBackButton(parent);
}

function revealSecondary(event) {
  const parent = event.target.parentNode;
  parent.classList.add('active');
  document.querySelector('.close_menu').innerHTML = 'Back';
  activateOverlayBackButton(parent);
}

function activateOverlayBackButton(parent) {
  const backOverlay = parent.querySelector('.back');
  backOverlay.addEventListener('click', closeNav);
}

function toggleSubnav(event) {
  if (window.innerWidth > 991) { return; }

  event.preventDefault();
  const secondaryOpen = document.querySelector('.subnav.active');

  if (secondaryOpen) {
    revealTertiary(event);
    secondaryOpen.classList.add('backgrounded');
  } else {
    revealSecondary(event);
  }
}

document.addEventListener('DOMContentLoaded', checkForMobileNav);
window.addEventListener('resize', checkForMobileNav);
